import StoreConstants from "@/store/StoreConstants";
import Vue from 'vue'
import Vuex from 'vuex'
import Api from "@/services/aws/Api";

Vue.use(Vuex)

let resolveAccountLoaded = null
let loadAccountPromise = new Promise(resolve => {
  resolveAccountLoaded = resolve
})

export default new Vuex.Store({
  state: {
    loadAccountPromise: loadAccountPromise,
    credentials: null,
    loggedIn: false,
    account: null
  },
  mutations: {
    [StoreConstants.commits.setCredentials] (state, credentials) {
      state.credentials = credentials
      if(credentials) {
        state.loggedIn = true
      } else {
        state.loggedIn = false
        state.account = null
      }
    },
    [StoreConstants.commits.setAccount] (state, account) {
      state.account = account
    }
  },
  actions: {
    async [StoreConstants.actions.loadAccount] ({ commit, state }) {
      try {
        let response = await Api.getAccount(state.credentials)

        if(response && response.data) {
          commit(StoreConstants.commits.setAccount, response.data)
          console.log('resolving resolveAccountLoaded')
          resolveAccountLoaded()
        }
      } catch(error) {
        console.log(error)
        throw error
      }
    },
  },
  getters: {
    isSubscribed: state => {
      return state.account && state.account.subscribed
    },
    isTeamOwner: state => {
      if(!state.account || !state.account.subscribed) {
        return false
      }

      const ownerAccountId = state.account.subscription.ownerAccountId
      return ownerAccountId === state.account.accountId
    },
    getTeamOwnerEmailAddress: state => {
      if(!state.account || !state.account.subscribed) {
        return false
      }

      return state.account.subscription.subscriptionOwnerEmail
    }
  },
  modules: {
  }
})
